import React from 'react';
import Dialog from '@mui/material/Dialog';
import '../css/loader.css';

const Loader = (props) => {
	const { open, LoaderType } = props;

	return (
		<div>
			<Dialog open={open} className="LoaderMain">
				{LoaderType === 1 ? <div className="Loader1" /> : null}
				{LoaderType === 2 ? (
					<div className="loader2">
						<span>Loading...</span>
					</div>
				) : null}
				{LoaderType === 3 ? (
					<div className="loader3">
						<span />
						<span />
						<span />
					</div>
				) : null}
				{LoaderType === 4 ? (
					<div class="loader4">
						<div class="finger finger-1">
							<div class="finger-item">
								<span />
								<i />
							</div>
						</div>
						<div class="finger finger-2">
							<div class="finger-item">
								<span />
								<i />
							</div>
						</div>
						<div class="finger finger-3">
							<div class="finger-item">
								<span />
								<i />
							</div>
						</div>
						<div class="finger finger-4">
							<div class="finger-item">
								<span />
								<i />
							</div>
						</div>
						<div class="last-finger">
							<div class="last-finger-item">
								<i />
							</div>
						</div>
					</div>
				) : null}
			</Dialog>
		</div>
	);
};

export default Loader;
